import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export default function CTABanner({ eyebrow, title, buttonLabel = "Get A Quote", buttonTo = "/contact", testId = "cta-banner" }) {
  return (
    <section className="bg-[#0B0B0B] py-24 md:py-32 border-y border-[#181818] relative overflow-hidden" data-testid={testId}>
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#F28C00] to-transparent" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <p className="cc-eyebrow justify-center mb-6">{eyebrow}</p>
        </Reveal>
        <Reveal delay={100}>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] mb-10">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={200}>
          <Link to={buttonTo} className="cc-btn-primary" data-testid={`${testId}-button`}>
            {buttonLabel} <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
